import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../AuthContext';

function PrivateRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <Box sx={{display:'flex', justifyContent:'center', py:8}}><CircularProgress /></Box>;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

PrivateRoute.propTypes = {children: PropTypes.node.isRequired};
export default PrivateRoute;


